import InterplayAppCoderLogo from "../assets/InterplayAppCoderLogo";
import { CustomFlex } from "./Layout.elements";
import IterateLogo from "../assets/IterateLogo";
import styled from "@emotion/styled";

const Division = styled.div`
  background-color: white;
  padding: 1.25rem 2.5rem;
  @media only screen and (max-width: 768px) {
    padding: 0;
  }
`;

const FlexSection = styled(CustomFlex)`
  margin: 0px 40px;
  height: 4rem;
  @media only screen and (max-width: 768px) {
    margin: 0;
    justify-content: center;
  }
`;


const Navbar = () => {
  return (
    <Division>
      <FlexSection content="space-between" alignItems="center">
        <InterplayAppCoderLogo />
        <IterateLogo />
      </FlexSection>
    </Division>
  );
};
export default Navbar;
